import { Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const TechnicalQuestionsPage = () => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '1rem' }}>
      <Title order={2}>{t('technical_questions')}</Title>
    </div>
  );
};

export default TechnicalQuestionsPage;
